import { Base } from '@codesuma/baseline'
import { ripple } from '../../utils/ripple'
import style from './index.module.css'

// The shared shell for the app's icon buttons (menu, plus): a circular tap target
// with the ripple and hover feedback baked in. Callers append their glyph, add
// any button-specific styling via base.addClass(...), and wire their own onclick.
export const IconButton = () => {
    const base = ripple(Base())
    base.addClass(style.base)
    return base
}
